module.exports = __webpack_public_path__ + "img/zizhi6.905ad7e8.png";